import { Configuration } from '../../../type/configuration';

export default {} as Configuration;